import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtml implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    public transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
